import { AutomationsView } from '@/components/views/AutomationsView';
import React from 'react';

export const AutomationsPage = () => {
	return <AutomationsView />;
};
